module.exports = __webpack_public_path__ + "img/Vanessa.2a219699.jpg";